import { getPdfFileName } from "../../context/loaders";

function sanitizeFileName(fileName: string): string {
  return encodeURIComponent(
    fileName.replace(/\//g, " ").replace(/"/g, " ").replace(/'/g, " "),
  );
}

export const createApplicationPdfLink = async (
  applicationRef: string,
): Promise<string> => {
  const { fileName } = await getPdfFileName(applicationRef);
  return `/commercial/api/protected/applications/${applicationRef}/${sanitizeFileName(
    fileName,
  )}`;
};
